module.exports = __webpack_public_path__ + "static/media/atendido.ece275ae.svg";